<nz-table nzSize="small" [nzData]="data">
  <thead>
    <tr style="display: flex">
      <th scope="col" style="flex: 1">Field</th>
      <th scope="col" style="flex: 1">Old Value</th>
      <th scope="col" style="flex: 1">New Value</th>
    </tr>
  </thead>
  <tbody>
    <tr style="display: flex" *ngFor="let row of getTableData();">
      <td style="white-space: pre; flex: 1">{{row.property}}</td>
      <td style="white-space: pre; flex: 1">{{row.oldValue || 'undefined'}}</td>
      <td style="white-space: pre; flex: 1">{{row.newValue || 'undefined'}}</td>
    </tr>
  </tbody>
</nz-table>
